import { Component, Input, OnChanges, OnInit ,OnDestroy, AfterViewInit, ChangeDetectorRef} from '@angular/core';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css']
})
export class CompanyComponent implements AfterViewInit {

  _subPage:string = 'vision';
  scrollPage:string = '';

  private subscriptions = new Array();
  constructor(private route:ActivatedRoute,
              private cdr: ChangeDetectorRef
    ) {
    this.subscriptions.push(this.route.params.subscribe(params=>{
        let value:string = params.data;
        let checkString:number = value.indexOf('-');

        if(checkString<0){
          this.subPage = params.data;
          window.scrollTo(0,0);
        }
        else{
          this.subPage = value.slice(0,checkString);
          this.scrollPage = value.slice(checkString+1);
        }
    }));
    
  }

  ngAfterViewInit(): void{
  }

  set subPage(val) {
    this._subPage = val;
    setTimeout(() => {
      this.cdr.detectChanges();
    });
  }

  get subPage() {
    return this._subPage;
  }
  scrollMoveToView (){
    let page :any = document.getElementById(this.scrollPage)?.offsetTop;

  }

  afterload(){
    document.getElementById(this.scrollPage)?.scrollIntoView();
  }
  

  ngOnDestroy(){
    for (let sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

}
